// src/store/modules/blog.js
import blogService from '@/services/blogService';

export default {
  namespaced: true,
  state: {
    posts: [],
    totalPosts: 0,
    nextPage: null,
    previousPage: null,
    currentPost: null,
    loading: false,
    error: null
  },
  mutations: {
    SET_POSTS(state, response) {
      console.log('Setting posts in store:', response);

      // Check if the response has a paginated structure
      if (response && response.results) {
        state.posts = response.results;
        state.totalPosts = response.count;
        state.nextPage = response.next;
        state.previousPage = response.previous;
        console.log('Extracted posts from paginated response:', state.posts);
      } else if (Array.isArray(response)) {
        // Handle the case where the response is a direct array
        state.posts = response;
        console.log('Extracted posts from array response:', state.posts);
      } else {
        console.error('Unexpected response format:', response);
        state.posts = [];
      }
    },
    SET_CURRENT_POST(state, post) {
      console.log('Setting current post in store:', post);
      state.currentPost = post;
    },
    SET_LOADING(state, status) {
      console.log('Setting loading state:', status);
      state.loading = status;
    },
    SET_ERROR(state, error) {
      console.error('Setting error state:', error);
      state.error = error;
    }
  },
  actions: {
    fetchPosts({ commit }) {
      console.log('Fetching posts...');
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      return blogService.getPosts()
        .then(response => {
          console.log('Posts API response:', response);
          commit('SET_POSTS', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch(error => {
          console.error('Error fetching posts:', error);
          console.error('Error response:', error.response);
          commit('SET_ERROR', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    fetchPost({ commit }, slug) {
      console.log(`Fetching post with slug: ${slug}`);
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      return blogService.getPost(slug)
        .then(response => {
          console.log('Post API response:', response);
          commit('SET_CURRENT_POST', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch(error => {
          console.error(`Error fetching post with slug ${slug}:`, error);
          console.error('Error response:', error.response);
          commit('SET_ERROR', error);
          commit('SET_LOADING', false);
          throw error;
        });
    }
  }
};